import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollOnHome() {
    return null;
}

